import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveBalance } from '../../store/actions/invoiceFwdAction';
import { receiveWalletBalance } from '../../store/actions/walletFwdAction';

import ForwarderHeaderInvoiceBalance from './ForwarderHeaderInvoiceBalance';

import GhaModel from '../../models/Gha';
import ForwarderInvoiceBalance from '../../models/ForwarderGhaInvoiceBalance';

import { reMapAccountBalanceNames } from '../../utils/accountBalance';

interface ForwarderHeaderInvoiceBalanceContainerProps { 
  ghaInfo: GhaModel;
  receiveFwdBalance: (ghaId: number) => void;
  fwdBalance: ForwarderInvoiceBalance;
  eWalletBalance: ForwarderInvoiceBalance;
  receiveWalletBalance: (ghaId: number) => void;
  cssClassName?: string;
};

class ForwarderHeaderInvoiceBalanceContainer extends Component <ForwarderHeaderInvoiceBalanceContainerProps> {

  componentDidMount() {
    if (this.props.ghaInfo && this.props.ghaInfo.id !== -1 && this.props.ghaInfo.gha_fwd_config.pay_by_invoice_allowed) {
      this.props.receiveFwdBalance(this.props.ghaInfo.id);
    };
    if (this.props.ghaInfo && this.props.ghaInfo.id !== -1 && this.props.ghaInfo.gha_fwd_config.pay_by_wallet) {
      this.props.receiveWalletBalance(this.props.ghaInfo.id);
    };
  };

  componentDidUpdate(prevProps: ForwarderHeaderInvoiceBalanceContainerProps) {

    const newProps: ForwarderHeaderInvoiceBalanceContainerProps = this.props;
    if (prevProps.ghaInfo !== newProps.ghaInfo && newProps.ghaInfo && this.props.ghaInfo.id !== -1 && this.props.ghaInfo.gha_fwd_config.pay_by_invoice_allowed) {
      this.props.receiveFwdBalance(this.props.ghaInfo.id);
    };
    if (prevProps.ghaInfo !== newProps.ghaInfo && newProps.ghaInfo && this.props.ghaInfo.id !== -1 && this.props.ghaInfo.gha_fwd_config.pay_by_wallet) {
      this.props.receiveWalletBalance(this.props.ghaInfo.id);
    };
  };
    
  render() {

    const fwdBalance: ForwarderInvoiceBalance = reMapAccountBalanceNames(this.props.fwdBalance);
    const walletBalance: ForwarderInvoiceBalance = reMapAccountBalanceNames(this.props.eWalletBalance);

    return (
      <ForwarderHeaderInvoiceBalance
        invoiceAllowed={ this.props.ghaInfo.gha_fwd_config.pay_by_invoice_allowed }
        walletAllowed={ this.props.ghaInfo.gha_fwd_config.pay_by_wallet }
        balance={ fwdBalance }
        cssClassName={ this.props.cssClassName }
        eWalletBalance={ walletBalance }
      />
    )
  };
};

const mapStateToProps = (state: any, props: any) => {
  return {
    fwdBalance: state.fwdBalance,
    ghaInfo: state.ghaInfo,
    eWalletBalance: state.eWalletBalance
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveFwdBalance: (ghaId: number) => dispatch(receiveBalance(ghaId)),
    receiveWalletBalance: (ghaId: number) => dispatch(receiveWalletBalance(ghaId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForwarderHeaderInvoiceBalanceContainer);